import { FC, ReactNode } from "react";
import styled from "styled-components/native";

interface CheckBalanceProps {
  children?: ReactNode;
}

const CheckBalance: FC<CheckBalanceProps> = ({ children }) => {
  return <Text>{children}</Text>;
};

const Text = styled.Text`
  border-radius: 24px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.20);
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: #fff;
  align-self: flex-start;
`

export default CheckBalance;
